// Utility to get product data based on ID
// First looks in products.json list, then checks for specific JSON files

import productsList from '../data/products.json';

// Import demo products statically (webpack needs to know all imports at build time)
import demoProductData from '../data/products/demo.json';
import pehuenProductData from '../data/products/pehuen.json';

// Map of demo product IDs to their data
const DEMO_PRODUCTS = {
  demo: demoProductData,
  pehuen: pehuenProductData,
};

const FALLBACK = {
  id: 'not-found',
  type: 'generic',
  initiative: {
    name: 'Iniciativa no encontrada',
    subtitle: '',
    heroImage: '',
    heroImageAlt: '',
    summary: '',
    story: '',
    location: { name: '', region: '' },
    status: 'in-progress',
  },
  partner: { name: '', tagline: '', logo: '', website: '' },
  impact: { metrics: [], benefits: [] },
  roadmap: { title: '', milestones: [] },
  product: { name: '', image: '', origin: { location: '' } },
  brand: { tagline: '' },
};

/**
 * Get product data for a specific product ID
 * @param {string} id - Product ID from URL
 * @returns {Object} Product data (synchronous - JSON is bundled)
 */
export function getProductData(id) {
  if (DEMO_PRODUCTS[id]) {
    return DEMO_PRODUCTS[id];
  }

  const product = productsList.products.find((p) => p.id === id);
  if (product) {
    return product;
  }

  const defaultProduct = productsList.products.find((p) => p.id === 'default');
  if (defaultProduct) {
    return defaultProduct;
  }

  if (productsList.products.length > 0) {
    return productsList.products[0];
  }

  console.error('No product data found for ID:', id);
  return FALLBACK;
}
